import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EmailHeaderBlockCss } from '@core/typings/pdf.typing';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';
import { InlineStyle } from '@yourcause/common/rich-text-editor';

@Component({
    selector: 'gc-email-header-block',
    templateUrl: './email-header-block.component.html',
    styles: [
        EmailHeaderBlockCss
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EmailHeaderBlockComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() editable = false;
  @Input() tokenToInsert = '';
  @Output() onEditorBlur = new EventEmitter();
  @Output() titleChange = new EventEmitter<string>();

  color = this.clientSettingsService.get('clientBranding').brandPrimary;
  InlineStyle = InlineStyle;

  constructor (
    private clientSettingsService: ClientSettingsService
  ) { }

  onChange (title: string) {
    title = title?.replace(/<\/?[^>]+(>|$)/g, '');
    this.titleChange.emit(title);
  }
}
